import isLandingPageQuery from './isLandingPageQuery';
import isRelativePath from './isRelativePath';
import parseLocalizedUrl from './parseLocalizedUrl';

/**
 *
 * @param {string} url
 * @param {EditModeQuery} query
 * @return {string}
 */
const createEditModeUrl = (url, query) => {
  if (isRelativePath(url)) {
    const parsedUrl = parseLocalizedUrl(url);
    const cleanUrl = parsedUrl ? parsedUrl.path : url;
    const langCode = parsedUrl ? parsedUrl.locale : query.language;
    const finalUrl = cleanUrl.split('#')[0];
    let hash = '';

    if (cleanUrl.indexOf('#') !== -1) {
      hash = `#${cleanUrl.split('#')[1]}`;
    }

    const { authorization } = query;
    if (isLandingPageQuery(query)) {
      // @ts-ignore: typescript doesn't know about the landingPageCode property, because the function isLadingPageQuery is now in JavaScript.
      const { landingPageCode } = query;
      return `/edit_mode?path=${finalUrl}&language=${langCode}&landingPageCode=${landingPageCode}&authorization=${authorization}${hash}`;
    }
    return `/edit_mode?path=${finalUrl}&language=${langCode}&authorization=${authorization}${hash}`;
  }
  return url;
};

export default createEditModeUrl;
